import React, { useRef } from 'react'
import { ContentAttach, DocumentBasic, MenuMore } from '@fs/zion-icon'
import { IconButton, Button, useOverlay, QuickGlanceOverlay, FlowGrid } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import usePrisonAccess from '../../../../../Give/hooks/usePrisonAccess'

export default function HiddenMenu({ loading, personId, showRecordDetails = false, handleClickRecordDetails }) {
  const [t] = useTranslation()
  const menuOverlay = useOverlay()
  const menuRef = useRef()
  const { accessFromPrison, isReady } = usePrisonAccess()

  // Don't render the menu if it would be empty
  const shouldShowMenu = (personId || showRecordDetails) && !accessFromPrison && isReady
  if (!shouldShowMenu) {
    return null
  }

  return (
    <>
      <IconButton
        title={t('navigation.menu-button', 'More Tools')}
        Icon={MenuMore}
        onClick={() => menuOverlay.handleClick()}
        color="gray"
        size="md"
        ref={menuRef}
      />
      <QuickGlanceOverlay {...menuOverlay} placement="start" targetRef={menuRef}>
        <FlowGrid columnCount={1} orientation="vertical" gutters="pico">
          {personId && showRecordDetails && !accessFromPrison && isReady && (
            <Button
              disabled={loading}
              Icon={DocumentBasic}
              title={t('navigation.details-button', 'Record Details')}
              onClick={() => handleClickRecordDetails()}
              data-testid="record-details"
              linkName="Record Details"
            >
              {t('navigation.details-button', 'Record Details')}
            </Button>
          )}
          {personId && showRecordDetails && !accessFromPrison && isReady && (
            <Button
              disabled={loading}
              Icon={ContentAttach}
              title={t('attach.header', 'Attach To Tree')}
              onClick={() => {
                const arkPath = `/ark:/61903/${personId}`
                window.open(`/search/linker?ark=${encodeURIComponent(arkPath)}&sourceType=rii`)
              }}
              data-testid="attach-to-tree"
              linkName="Attach To Tree"
            >
              {t('attach.header', 'Attach To Tree')}
            </Button>
          )}
        </FlowGrid>
      </QuickGlanceOverlay>
    </>
  )
}
